import $ from 'jquery';
import { commonMiddleware, protectRoute } from '../middleware';
import ReactDOM from 'react-dom';
import React from 'react';
import { ProfilePage } from '~src/components/Profile';
import { trackPageView } from '~src/tracking';
import { initHomeExperience } from '~src/home';
import { initSidebarProfile } from '../../sidebar-profile';

export const profilerRoute = async () => {
  document.title = 'Profilo | Giotto';

  await protectRoute();
  await commonMiddleware();
  // Align layout/visibility with Home and Projects
  $('#navbar-private').hide();
  $('#navbar-canvas').hide();
  $('.logo').hide();

  // Use dashboard layout styling
  $('body').addClass('dashboard');

  // Show route and render into the profile root container
  $('#route-profiler').show();
  // Ensure design-system sidebar and interactions are initialized after visible
  initHomeExperience();
  initSidebarProfile();
  const domContainer = document.querySelector('#profile-root');
  ReactDOM.render(React.createElement(ProfilePage), domContainer);
  trackPageView('Profile');
};
